








import { Vue, Component, Prop } from 'vue-property-decorator';

import DetailedSlotGeneric from './DetailedSlotGeneric.vue';

import { PatientChosenSlot } from '../types';

@Component({
    components: {
        DetailedSlotGeneric,
    },
})
export default class DetailedSlotFree extends Vue {
    @Prop() event!: PatientChosenSlot;

}
